import { render } from "./SubmittalField.vue?vue&type=template&id=7a27d24d&scoped=true"
import script from "./SubmittalField.vue?vue&type=script&lang=js"
export * from "./SubmittalField.vue?vue&type=script&lang=js"

import "./SubmittalField.vue?vue&type=style&index=0&id=7a27d24d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a27d24d"]])

export default __exports__